import * as moment from 'moment';
import { Action, ActionCreator, AnyAction } from 'redux';
import { Dispatch } from 'react-redux';
import { ThunkAction } from 'redux-thunk';
import { AuthActionType, inProgress, success, fail } from '.';
import { API } from '../api';
import { AuthResponse } from '../api/model';
import { StoreState } from '../store';
import localStore from '../utils/LocalStore';

//#region UserAuthenticated
export interface UserAuthenticatedAction extends AnyAction {
    type: AuthActionType.UserAuthenticated;
    token: AuthResponse;
}

export interface AuthTokenAsyncActionCreator extends ActionCreator<ThunkAction<Promise<AuthResponse>, StoreState, void>> {
    (username: string, password: string): ThunkAction<Promise<AuthResponse>, StoreState, void>;
}

export interface AuthTokenActionCreator extends ActionCreator<Promise<AuthResponse>> {
    (username: string, password: string): Promise<AuthResponse>;
}

const userAuthenticated: ActionCreator<UserAuthenticatedAction> = (token: AuthResponse) => {
    return {
        type: AuthActionType.UserAuthenticated,
        token
    };
};

export const authTokenAsync: AuthTokenAsyncActionCreator = (username: string, password: string) =>
    (dispatch: Dispatch<StoreState>, getState: () => StoreState): Promise<AuthResponse> =>
        API.auth.token(username, password)
            .then(authResponse => {
                localStore.storeAuth({
                    token: authResponse.token,
                    date: moment.now()
                });
                dispatch(userAuthenticated(authResponse));
                return authResponse;
            });
//#endregion

//#region UserLoggedOut
export interface UserLoggedOutAction extends Action {
    type: AuthActionType.UserLoggedOut;
}

export interface AccountLogoutAsyncActionCreator extends ActionCreator<ThunkAction<Promise<void>, StoreState, void>> {
    (): ThunkAction<Promise<void>, StoreState, void>;
}

export interface AccountLogoutActionCreator extends ActionCreator<Promise<void>> {
    (): Promise<void>;
}

const userLoggedOut: ActionCreator<UserLoggedOutAction> = () => {
    return {
        type: AuthActionType.UserLoggedOut
    };
};

export const accountLogoutAsync: AccountLogoutAsyncActionCreator = () =>
    (dispatch: Dispatch<StoreState>): Promise<void> => {
        dispatch(inProgress());
        return new Promise((resolve, reject) => {
            localStore.clearStore();
            resolve();
        })
            .then(res => {
                dispatch(success());
                dispatch(userLoggedOut());
            })
            .catch(error => {
                dispatch(fail());
                dispatch(userLoggedOut());
            });
    };
//#endregion

export type AuthAction =
    | UserAuthenticatedAction
    | UserLoggedOutAction;



// WEBPACK FOOTER //
// ./src/actions/authActions.ts